<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="defaultTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{disassembleOrder.billNo}}</td>
            <td class="tableLabel">申请人人：</td>
            <td>{{disassembleOrder.creatorName}}</td>
            <td class="tableLabel">申请日期：</td>
            <td>{{disassembleOrder.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">提交时间：</td>
            <td>{{disassembleOrder.submitTime}}</td>
            <td class="tableLabel">退料单号：</td>
            <td>{{disassembleOrder.returnOrderNo}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{disassembleOrder.factoryNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理类型：</td>
            <td>
              {{constant.dealType[disassembleOrder.dealType]}}
            </td>
            <td class="tableLabel">拆解号：</td>
            <td>{{disassembleOrder.disassemblyNo}}</td>
            <td class="tableLabel">流程状态：</td>
            <td>{{disassembleOrder.nodeDesc}}</td>
          </tr>
        </table>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            物料信息
          </div>
          <el-table
              :data="disassembleOrder.details">
            <el-table-column prop="materialNo" align="center" label="物料编号"/>
            <el-table-column prop="materialName" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量"/>
            <el-table-column prop="unit" align="center" label="单位"/>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import constant from "@/util/constant";

  export default {
    name: "",
    components: {HandleDetail},
    data() {
      return {
        constant,
        billId: "",
        billType: "36",
        saveLoading: false,
        disassembleOrder: {
          pkid: "",
          billNo: "",
          creatTime: "",
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.disassembleOrder = {};
    },
    methods: {
      getData() {
        this.$http.get("basic", `disassembleOrders/${this.billId}`).then((res) => {
          this.disassembleOrder = res;
        }).catch(() => {
        });
      },
    },
  };
</script>

<style lang="scss">
table.defaultTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.defaultTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.defaultTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
